export default function HorizontalScroller({
    children,
    className = '',
    viewportClassName = '',
}) {
    return (
        <div className={`horizontal-scroller ${className}`.trim()}>
            <div className={`horizontal-scroller-viewport ${viewportClassName}`.trim()}>
                {children}
            </div>
        </div>
    )
}
